(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.site-header-vsb').forEach(function (root) {

    var sectionId = root.getAttribute('data-section-id');

    var triggers = root.querySelectorAll('.mega-trigger-vsb');
    var panels = root.querySelectorAll('.mega-panel-vsb');

    function closeAllPanels() {
      panels.forEach(function (panel) {
        panel.classList.remove('is-open-vsb');
      });

      triggers.forEach(function (trigger) {
        trigger.classList.remove('is-open-vsb');
        trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function openPanel(trigger) {
      var key = trigger.getAttribute('data-menu');
      var panel = root.querySelector('.mega-panel-vsb[data-panel="' + key + '"]');

      if (!panel) return;

      closeAllPanels();

      panel.classList.add('is-open-vsb');
      trigger.classList.add('is-open-vsb');
      trigger.setAttribute('aria-expanded', 'true');
    }

    triggers.forEach(function (trigger) {

      // Click
      trigger.addEventListener('click', function (e) {
        var hasUrl = trigger.getAttribute('data-has-url') === 'true';

        // If this menu item has its own real URL (set in Shopify nav),
        // let the click navigate there normally — don't intercept it.
        if (hasUrl) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        var key = trigger.getAttribute('data-menu');
        var panel = root.querySelector('.mega-panel-vsb[data-panel="' + key + '"]');

        if (!panel) return;

        if (panel.classList.contains('is-open-vsb')) {
          closeAllPanels();
        } else {
          openPanel(trigger);
        }
      });

      // Hover (Desktop only)
      trigger.addEventListener('mouseenter', function () {
        if (window.innerWidth > 860) {
          openPanel(trigger);
        }
      });

    });

    // Hover directly between menu items
    panels.forEach(function (panel) {
      panel.addEventListener('mouseenter', function () {
        if (window.innerWidth <= 860) return;

        var key = panel.getAttribute('data-panel');
        var trigger = root.querySelector('.mega-trigger-vsb[data-menu="' + key + '"]');

        if (trigger) {
          openPanel(trigger);
        }
      });
    });

    // Close when leaving header
    root.addEventListener('mouseleave', function () {
      if (window.innerWidth > 860) {
        closeAllPanels();
      }
    });

    root.querySelectorAll('.js-close-mega-vsb').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeAllPanels();
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.site-header-vsb[data-section-id="' + sectionId + '"]')) {
        closeAllPanels();
      }
    });

    window.addEventListener('scroll', function () {
      root.classList.toggle('is-solid-vsb', window.scrollY > 40);
    });

    // Desktop inline search: "Search" text toggles into a search input line, same spot
    var searchWrap = root.querySelector('.search-wrap-vsb');

    if (searchWrap) {
      var searchToggle = searchWrap.querySelector('.search-toggle-vsb');
      var searchInput = searchWrap.querySelector('.header-search-input-vsb');

      searchToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isOpen = searchWrap.classList.toggle('is-open-vsb');
        searchToggle.setAttribute('aria-expanded', isOpen);

        if (isOpen) {
          setTimeout(function () { searchInput.focus(); }, 150);
        }
      });

      document.addEventListener('click', function (e) {
        if (!e.target.closest('.search-wrap-vsb')) {
          searchWrap.classList.remove('is-open-vsb');
          searchToggle.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          searchWrap.classList.remove('is-open-vsb');
          searchToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Mobile Drawer
    var hamburgerBtn = root.querySelector('.hamburger-vsb');
    var drawer = document.getElementById('MobileDrawerVsb-' + sectionId);

    if (hamburgerBtn && drawer) {

      hamburgerBtn.addEventListener('click', function (e) {
        e.preventDefault();

        var isOpen = drawer.classList.toggle('is-open-vsb');

        hamburgerBtn.classList.toggle('is-active-vsb', isOpen);
        hamburgerBtn.setAttribute('aria-expanded', isOpen);

        document.body.style.overflow = isOpen ? 'hidden' : '';
      });

      drawer.querySelectorAll('.drawer-accordion-vsb').forEach(function (item) {
        var row = item.querySelector('.drawer-row-vsb');

        if (row) {
          row.addEventListener('click', function () {
            item.classList.toggle('is-expanded-vsb');
          });
        }
      });

      drawer.querySelectorAll('.sub-group-title-vsb').forEach(function (title) {
        title.addEventListener('click', function () {
          title.parentElement.classList.toggle('is-open-vsb');
        });
      });
    }

    // Mobile top search bar (opens at header height, over the header)
    var mobileSearchToggle = root.querySelector('.search-icon-toggle-vsb');
    var mobileSearchBar = document.getElementById('MobileSearchBarVsb-' + sectionId);

    if (mobileSearchToggle && mobileSearchBar) {
      var mobileSearchInput = mobileSearchBar.querySelector('.mobile-search-input-vsb');
      var mobileSearchClose = mobileSearchBar.querySelector('.js-close-mobile-search-vsb');

      mobileSearchToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        mobileSearchBar.classList.add('is-open-vsb');
        mobileSearchToggle.setAttribute('aria-expanded', 'true');

        setTimeout(function () { mobileSearchInput.focus(); }, 200);
      });

      if (mobileSearchClose) {
        mobileSearchClose.addEventListener('click', function () {
          mobileSearchBar.classList.remove('is-open-vsb');
          mobileSearchToggle.setAttribute('aria-expanded', 'false');
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          mobileSearchBar.classList.remove('is-open-vsb');
          mobileSearchToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

  });

});

  } catch(e) { console.error(e); }
})();
})();
